export default function Cart (props) {
  const { quantity, handleShowBasket = Function.prototype } = props;

  return (
    <div className="cart-icon" onClick={handleShowBasket}>
      <i className="material-icons">shopping_cart</i>
      {quantity > 0 && (
        <span className="cart-quantity-badge">{quantity}</span>
      )}
    </div>
  );
}